import { useSelector } from 'react-redux';
import AccessLog from '../../../Contractor/Contracts/SubComponents/EmployeeDetailsFlows/AccessLog/AccessLog';
import CustomTooltip from '../../../../components/CustomTooltip';
import { DocumentPlus, PersonChip } from '../../../../components/buttons/IconButtons';
import CustomModal from '../../../../components/Modal/CustomModal';
import AccessLogModalApp from '../Functionality/AccessLogModalApp';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import CustomChip from '../../../../components/CustomChip';
import CustomCard from './../../../../components/CustomCard';
import { statusBorderColor, statusColor, statusFontColor } from './../../../../enums/statusColorEnum';
import { status } from './../../../../enums/statusEnum';
import { EMPTY_VALUES } from '../../../../Apis/functions';
import { permissionObj } from '../../../../Helpers/permission';
import { ACCESS_LOG_GET_DATA } from '../Model/Models';

const AccessLogModal = (props) => {
    const { item, supplierId } = props;
    const {  t,
        moduleId,
        option,
        body,
        displayModal,
        setDisplayModal
    } = AccessLogModalApp({ userId: item?.id });
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const loggedContractorId = sessionStorage.getItem('contractorId');
    const loggedSupplierId = sessionStorage.getItem('providerId');
    // Contractors and suppliers export their own employees, employees need the permission
    // of the section the access log was opened from
    const exportPermission = loggedContractorId || loggedSupplierId || DEV || permission?.includes(
        supplierId ? permissionObj?.WEB_SUPPLIER_EXPORT : permissionObj?.WEB_CONTRACTOR_EXPORT
    );

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            confirmButton={false}
            cancelButton={false}
            classNameBody='m-0 p-0'
            display={displayModal}
            topLeftHeader={
                <>
                    <div className='d-flex align-items-center pb-3'>
                        <DocumentPlus width={32} height={32} />
                        <div className={'flex-grow-1 minw-0 '}>
                            <CustomTooltip
                                text={t('access_log')}
                                classes={'font-color-general-950 ibl-font-w-600 fs-24px text-ellipsis-1-row ml-2'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                </>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <div className='d-flex align-items-center justify-content-between mx-2'>
                    <div className='d-flex align-items-center mx-2'>
                        <PersonChip className='w-32px h-32px' />
                        <p className='fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row mb-3 mt-3 ml-3 text-capitalize'>
                            {item?.name}
                        </p>
                    </div>
                    <div className='mr-2'>
                        <CustomChip
                            variant='large'
                            background={statusColor[item.statusId]}
                            fontColor={statusFontColor[item.statusId]}
                            borderColor={statusBorderColor[item.statusId]}
                            legend={t(status[item.statusId]) || EMPTY_VALUES.DEFAULT}
                        />
                    </div>
                </div>
                <div className={'border-bottom-shades-300'} />
                {exportPermission &&
                    <div className='d-flex justify-content-end mx-3 mt-3'>
                        <ExportDataBtn
                            classes='btn-outlined-secondary-600-00 btn-icon-svg btn-icon-svg-general'
                            id='btn_alm_export'
                            moduleId={moduleId}
                            body={body}
                            search={false}
                            option={option}
                            contractorSupplier={false}
                            setDisplayModal={setDisplayModal}
                        />
                    </div>
                }
                <div className='mx-2 mb-0'>
                    <AccessLog
                        id={item?.id}
                        option={option}
                        accessLogMode={ACCESS_LOG_GET_DATA.USER.name}
                    />
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default AccessLogModal;
